import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';

import { Toggle, ToggleField, RemoteAutoCompleteField, RemoteAutoComplete, InputField, Input } from '@components/form';
import { FormSection } from 'redux-form';

const View: React.SFC<any> = ({ change, editable }) => (
  <div>
    <Grid fluid={true}>
      <FormSection name="otherSettings">
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <Col md={6}>
            <InputField
              component={Input}
              name="ticketNumberPlaces"
              type="number"
              label="Počet míst u evidenčního čísla bloku"
              disabled={!editable}
            />
          </Col>
          <Col md={6}>
            <RemoteAutoCompleteField
              component={RemoteAutoComplete}
              name="eventDefaultPlace"
              disabled={!editable}
              label={'Výchozí místo události'}
              url="/metropolis/api/address/place"
              fullWidth={true}
              labelFunction={o => get(o, 'name')}
              valueFunction={o => o}
            />
          </Col>
          <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
            <ToggleField
              component={Toggle}
              disabled={!editable}
              name="eventColorActive"
              label="Zbarvení události"
              labelPosition="right"
              onToggle={(_, value) => {
                change('otherSettings.eventColorActive', value);
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </FormSection>
    </Grid>
    <Divider />
  </div>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/generalSettings/GeneralSettingsFormOthers.tsx